// ProductionPieChart.jsx
import React from "react";
import { Box, Card, CardContent, Typography } from "@mui/material";
import { ResponsivePie } from "@nivo/pie";
import { useTheme } from "@mui/material/styles";
import { tokens } from "../../../theme/theme";

export default function ProdProductionPieChart({ production }) {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const nivoTheme = {
    textColor: colors.grey[100],
    tooltip: { container: { background: colors.primary[400], color: colors.grey[100] } },
    legends: { text: { fill: colors.grey[100] } },
  };

  const pieData = [
    { id: "Reels", label: "Reels", value: production.produced_reels },
    { id: "Reams", label: "Reams", value: production.produced_reams },
    { id: "Bundles", label: "Bundles", value: production.produced_bundle_pallet },
  ];

  return (
    <Card sx={{ borderRadius: 2, boxShadow: 3 }}>
      <CardContent>
        <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>
          Production Mix (Today)
        </Typography>

        <Box sx={{ height: 320 }}>
          <ResponsivePie
            data={pieData}
            margin={{ top: 20, right: 20, bottom: 60, left: 20 }}
            innerRadius={0.45}
            padAngle={1}
            cornerRadius={6}
            activeOuterRadiusOffset={8}
            colors={{ scheme: theme.palette.mode === "dark" ? "dark2" : "paired" }}
            borderWidth={1}
            borderColor={{ from: "color", modifiers: [["darker", 0.2]] }}
            arcLabelsSkipAngle={10}
            arcLabel={(d) => `${d.value}`}
            theme={nivoTheme}
            legends={[
              {
                anchor: "bottom",
                direction: "row",
                justify: false,
                translateY: 36,
                itemWidth: 90,
                itemHeight: 20,
                itemTextColor: colors.grey[100],
                symbolSize: 12,
                symbolShape: "circle",
              },
            ]}
            tooltip={({ datum }) => (
              <div style={{ padding: 8, background: colors.primary[400], color: colors.grey[100], borderRadius: 6 }}>
                <strong>{datum.id}</strong>
                <div>{datum.value}</div>
              </div>
            )}
          />
        </Box>
      </CardContent>
    </Card>
  );
}
